<div class="col-md-12 main-heading">
  <div class="d-flex">
    <a routerLink="/index">
      <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
    </a>
    <div class="caption-heading">Fastag Reconciliation</div>
  </div>
</div>
<div class="col-md-12 pagecustom">
  <div class="page-wrapper">
    <div class="row main-container boxscroll">
      <div class="block-section width-lg-metro" style="width: 90%;">
        <div class="heading-m" style="height: 37px;">
        </div>
        <div class="list-sidebar">
          <table style="width: 100%;">
            <tbody>
              <tr>
                <td>
                  <style>
                    .formFilter tbody tr td {
                      padding-left: 10px;
                    }
                  </style>
                  <table class="formFilter">
                    <tbody>
                      <tr>
                        <td>
                          Vehicle Number
                        </td>
                        <td class="form-group">
                          <input type="text"
                                 placeholder="Vehicle number"
                                 [(ngModel)]="vehicleNumber"
                                 class="form-control">
                        </td>
                        <td>
                          From Date Time
                        </td>
                        <td>
                          <input type="text"
                                 placeholder="From Date"
                                 class="form-control"
                                 [(ngModel)]="fromDate"
                                 [bsConfig]="{containerClass:'theme-dark-blue', isAnimated: true,adaptivePosition: true,dateInputFormat: 'DD-MM-YYYY HH:mm:ss' }"
                                 bsDatepicker>
                        </td>
                        <td>
                          To Date Time
                        </td>
                        <td>
                          <input type="text"
                                 placeholder="To Date"
                                 class="form-control"
                                 [(ngModel)]="toDate"
                                 [bsConfig]="{containerClass:'theme-dark-blue', isAnimated: true,adaptivePosition: true,dateInputFormat: 'DD-MM-YYYY HH:mm:ss' }"
                                 bsDatepicker>
                        </td>
                        <td>
                          <button class="btn btn-primary" (click)="SearchData()">Search</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <style>
                    .formData {
                      margin: 20px;
                      border: solid 1px darkgray;
                      width: calc(100% - 20px);
                    }

                      .formData thead tr th {
                        padding: 10px;
                      }

                      .formData tbody tr td {
                        padding: 10px;
                      }

                      .formData tbody tr td {
                        font-weight: normal;
                      }
                  </style>
                  <table class="formData">
                    <thead>
                      <tr>
                        <th>
                          VEHICLE NUMBER
                        </th>
                        <th>
                          FASTAGE TAG NUMBER
                        </th>
                        <th>
                          ENTRY DATE TIME
                        </th>
                        <th style="width: 40%;">
                          REMARK
                        </th>
                        <th>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let SELECT_FASTAG_RECONCILATION of SELECT_FASTAG_RECONCILATION_LIST">
                        <td>
                          {{SELECT_FASTAG_RECONCILATION.VEHICLE_NUMBER}}
                        </td>
                        <td>
                          {{SELECT_FASTAG_RECONCILATION.FASTAGE_TAG_NUMBER}}
                        </td>
                        <td>
                          {{SELECT_FASTAG_RECONCILATION.ENTRY_DATE_TIME}}
                        </td>
                        <td>
                          <input type="text"
                                 placeholder="Remark"
                                 id="remark{{SELECT_FASTAG_RECONCILATION.OPERATION_NUMBER}}"
                                 [(ngModel)]="remark"
                                 class="form-control">
                        </td>
                        <td>
                          <button class="btn btn-primary" (click)="KnockOff(SELECT_FASTAG_RECONCILATION.OPERATION_NUMBER)">Knock off</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#KnockOffModal" id="KnockOffModalButton" style="display: none;">
  Launch demo modal
</button>
<div class="modal fade" id="KnockOffModal" tabindex="-1" role="dialog" aria-labelledby="KnockOffModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="KnockOffModalLabel">
          Knock Off?
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="KnockOffModalCloseButton">
            <span aria-hidden="true">&times;</span>
          </button>
        </h3>
      </div>
      <div class="modal-body">
        <h5>
          Do you want to manual knock off vehicle entry?
        </h5>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-danger" data-dismiss="modal" aria-label="Close" id="KnockOffModalYesButton" (click)="KnockOffYes()">Yes</button>
        <button type="button" class="btn btn-warning" data-dismiss="modal" aria-label="Close" id="KnockOffModalNoButton">
          No
        </button>
      </div>
    </div>
  </div>
</div>
